var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburgerclose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60.06 42.15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 21.08,
    x2: 60.06,
    y2: 21.08,
    gradientTransform: "matrix(0.721243,0,0,0.560113,12.579659,15.730394)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3,
    y1: 3.75,
    x2: 48.06,
    y2: 3.75,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, 1, 3.555999, 7.536106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007bff",
    id: "stop20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017aff",
    id: "stop22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2f6aff",
    id: "stop24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#565dff",
    id: "stop26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7652ff",
    id: "stop28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#8e49ff",
    id: "stop30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#a043ff",
    id: "stop32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#aa40ff",
    id: "stop34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ae3fff",
    id: "stop36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-3",
    x1: 0,
    y1: 21.08,
    x2: 60.060001,
    y2: 21.08,
    gradientTransform: "matrix(0.721243,0,0,0.560113,12.579659,15.730394)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("style", {
    id: "style18"
  }, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    transform: "matrix(-0.724681, 0.697697, -0.724681, -0.697697, 70.735062, 17.005016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 50.622,25.418 H 12.72 c -1.494,0 -2.705,-0.942 -2.705,-2.101 0,-1.159 1.211,-2.1 2.705,-2.1 h 37.902 c 1.493,0 2.704,0.941 2.704,2.1 0,1.159 -1.211,2.101 -2.704,2.101 z",
    style: {
      fill: "url(#linear-gradient-2)"
    },
    transform: "rotate(90,31.670501,23.317499)",
    id: "path42"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1",
    transform: "matrix(-0.697014, -0.723354, 0.751331, -0.67106, 35.484432, 60.998051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1-7",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 50.622,25.418 H 12.72 c -1.494,0 -2.705,-0.942 -2.705,-2.101 0,-1.159 1.211,-2.1 2.705,-2.1 h 37.902 c 1.493,0 2.704,0.941 2.704,2.1 0,1.159 -1.211,2.101 -2.704,2.101 z",
    style: {
      fill: "url(#linear-gradient-2-3)"
    },
    transform: "rotate(90,31.670501,23.317499)",
    id: "path42-0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerclose);
export default __webpack_public_path__ + "static/media/hamburgerclose.527df0a4d87e8ca2b7661e59917dc651.svg";
export { ForwardRef as ReactComponent };